/*
 * What a search hit hands the page it opens, beside the address: the words it matched (S-09 §3.3).
 * A section of a document opens at `/drive/<key>#<heading id>` with the find bar holding the hit's
 * first marked run, and that run is a search term — so it rides the router's memory of the history
 * entry (`history.state`) and never the address, which reaches the browser history, the Referer header
 * and every access log (spec 10, A26). Back and Forward bring the entry's memory with it, so stepping
 * back onto the document opens the find bar again; a pasted or reloaded address carries none.
 *
 * The one key is spelled here, beside the two functions that write and read it, so the search page
 * and the document page cannot disagree about it.
 */

/** What a hit hands the page it opens. */
export interface OpenMemory {
	/** The words the find bar opens with. */
	find?: string | undefined
}

/** The key of the history entry's state the find words are kept under. */
const FIND_KEY = "tbFind"

/** The history state that carries `memory`, or undefined when there is nothing to carry. */
export function historyStateOf(memory: OpenMemory | undefined): Record<string, string> | undefined {
	const find = memory?.find?.trim() ?? ""
	return find === "" ? undefined : { [FIND_KEY]: find }
}

/** The find words a history entry's state carries, or undefined. */
export function findOfState(state: unknown): string | undefined {
	if (typeof state !== "object" || state === null) return undefined
	const find = (state as Record<string, unknown>)[FIND_KEY]
	return typeof find === "string" && find !== "" ? find : undefined
}
